import { useGenUiI18n } from '../../shared/ui/i18n.js';
import type { PlaceDetails } from '@voll-intelligence/genui-contract';
export function mapsLink(place: Pick<PlaceDetails, 'googleMapsUri' | 'placeId' | 'name'>): string {
  if (place.googleMapsUri) return place.googleMapsUri;
  const query = new URLSearchParams({ api: '1', query: place.name, query_place_id: place.placeId });
  return `https://www.google.com/maps/search/?${query.toString()}`;
}

function priceGlyph(level: number | undefined): string | undefined {
  return level === undefined ? undefined : '$'.repeat(level);
}

export function PlaceFacts({ place }: { readonly place: PlaceDetails }) {
  const { locale, t } = useGenUiI18n();
  const rating =
    place.rating === undefined
      ? undefined
      : new Intl.NumberFormat(locale, { maximumFractionDigits: 1 }).format(place.rating);
  const count =
    place.userRatingCount === undefined
      ? undefined
      : new Intl.NumberFormat(locale, { notation: 'compact' }).format(place.userRatingCount);
  return (
    <p className="flex flex-wrap gap-x-2 text-sm text-muted-foreground">
      {rating && <span aria-label={t('consultPlaces.rating', { rating })}>★ {rating}</span>}
      {count && <span>({count})</span>}
      {place.openNow !== undefined && (
        <span className={place.openNow ? 'text-success' : 'text-muted-foreground'}>
          {place.openNow ? t('consultPlaces.open') : t('consultPlaces.closed')}
        </span>
      )}
      {priceGlyph(place.priceLevel) && <span>{priceGlyph(place.priceLevel)}</span>}
    </p>
  );
}
